import 'css-chunksrc/client/pages/occupancyPage/toolbar/yearNavigation/styles.scss';export default {
  "root": "_root_jfxoe_1",
  "yearNavigation": "_yearNavigation_jfxoe_5",
  "arrow": "_arrow_jfxoe_16",
  "leftArrow": "_leftArrow_jfxoe_23",
  "rightArrow": "_rightArrow_jfxoe_30",
  "year": "_year_jfxoe_5",
  "calendarButton": "_calendarButton_jfxoe_45",
  "opened": "_opened_jfxoe_54",
  "calendarIcon": "_calendarIcon_jfxoe_54",
  "listRoot": "_listRoot_jfxoe_64"
};